export const POPULATE = 'LandingZoneTeamsPopulate'

export const SET_LOADED = 'LandingZoneTeamsSetLoaded'

export const SET_FORMAT = 'LandingZoneTeamsSetFormat'